import moment from 'moment-timezone';
export var TIMEZONE = process.env.TZ || 'Australia/Sydney';
export var ListedDateTypeKeys = ['TODAY', 'YESTERDAY', 'WITHIN_LAST_WEEK', 'SPECIFIC_DATE'];
export var ListedDateType = {
  TODAY: {
    name: 'TODAY',
    offsetStart: 0,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Today%date',
    labelDateFormat: ', D MMMM'
  },
  YESTERDAY: {
    name: 'YESTERDAY',
    offsetStart: -1,
    offsetEnd: -1,
    offsetUnit: 'days',
    labelTemplate: 'Yesterday%date',
    labelDateFormat: ', D MMMM'
  },
  WITHIN_LAST_WEEK: {
    name: 'WITHIN_LAST_WEEK',
    offsetStart: -7,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Within the last week'
  },
  SPECIFIC_DATE: {
    name: 'SPECIFIC_DATE',
    labelTemplate: '%date',
    labelDateFormat: 'dddd, D MMMM'
  }
};
var momentFormatter = (offset, offsetUnit, format, dateOverride) => {
  if (format) {
    var instance;
    if (offsetUnit) {
      instance = moment().tz(TIMEZONE).add(offset, offsetUnit);
    } else if (dateOverride) {
      instance = moment.tz(dateOverride, TIMEZONE);
    }
    return instance && instance.isValid() ? instance.format(format) : '';
  }
  return '';
};
export var getDateTypeLabel = function getDateTypeLabel(listedDateType, dateOverride) {
  var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : momentFormatter;
  if (listedDateType && listedDateType.labelTemplate) {
    var label = listedDateType.labelTemplate;
    if (label.includes('%date') && listedDateType.labelDateFormat) {
      var formattedDate = formatter(listedDateType.offsetStart, listedDateType.offsetUnit, listedDateType.labelDateFormat, dateOverride) || '';
      label = label.replace('%date', formattedDate);
    }
    return label.trim();
  }
  return undefined;
};
export var parseListedDateType = value => {
  if (!value) {
    return null;
  }
  var upperCaseValue = "".concat(value).toUpperCase();
  if (ListedDateTypeKeys.includes(upperCaseValue)) {
    return upperCaseValue;
  }
  return null;
};